const getCurrentPrice = require('./get-current-price')

// DEFAULT_COLUMNS is the default header and content to be displayed in our exported
// it supports both string value or object value
// if object the value is gotten from the .transform (or product[key] when omitted)
// else we just use the keys(Object.keys(DEFAULT_COLUMNS)) to extrapolate the value from product: product[key] and title
const column = (title, description, transform) => {
  const value = { title, description }
  if (transform) {
    value.transform = transform
  }
  return value
}

const DEFAULT_COLUMNS = {
  _id: column(
    'Product Id',
    'Unique product id. Uneditable, required on create.',
    product => product._id.toLowerCase()
  ),
  code: column('Code', 'Short product code (must be the same as the Product ID but without the "product:" prefix). Uneditable, required on create.'),
  name: column('Name', 'Short product name. Editable, required on create.'),
  fullName: column('Full Name', 'Full product name. Editable, required on create.'),
  productType: column('Product Type', 'Type of product (e.g. vaccine)'),
  storageType: column('Storage Type', 'One of cold-chain or non cold-chain. Editable, required on create.'),
  basicUnit: column('Basic Unit', 'The smallest unit the product is counted in, e.g. Tablet. Optional.'),
  presentation: column('Presentation', '---------- TBD ----------'),
  prices: column(
    'Current Price',
    'The product\'s current selling price. Optional.',
    product => getCurrentPrice(product.prices)
  ),
  maxPrice: column(
    'Current Max Price',
    'Current maximum price',
    product => getCurrentPrice(product.prices, 'maxPrice')
  ),
  buyPrice: column(
    'Current Buy Price',
    'Current buy price',
    product => getCurrentPrice(product.buyPrices, 'buyPrice')
  ),
  vat: column(
    'Current VAT',
    'Current VAT rate',
    product => getCurrentPrice(product.vats, 'vat')
  ),
  description: column('Description', 'Product description. Optional.')
}

const getColumnTitle = columnValue =>
  typeof columnValue === 'string' ? columnValue : columnValue.title

const normalizeColumn = (key, value) => {
  if (typeof value === 'object') {
    return {
      title: value.title,
      description: value.description || '',
      transform: value.transform || (product => product[key])
    }
  }
  return {
    title: value,
    description: '',
    transform: product => product[key]
  }
}

const getRows = (products, opts = {}) => {
  opts = Object.assign({
    exclude: [],
    additionalColumns: {}
  }, opts)

  // can't exlude _id from export, since we need it for import
  opts.exclude = opts.exclude.filter(i => i !== '_id')

  const isExcluded = key => opts.exclude.indexOf(key) > -1
  const columns = Object.assign({}, DEFAULT_COLUMNS, opts.additionalColumns)

  const columnProps = Object.keys(columns).filter(key => !isExcluded(key))
    .map(key => normalizeColumn(key, columns[key]))

  const headers = columnProps.map(columnProp => columnProp.title)
  const descriptions = columnProps.map(columnProp => columnProp.description)
  const rows = []

  for (let product of products) {
    rows.push(columnProps.map(columnProp => columnProp.transform(product)))
  }

  return { rows, headers, descriptions }
}

module.exports = {
  DEFAULT_COLUMNS, getRows, getColumnTitle
}
